export default __webpack_public_path__ + "static/media/PelatihanOlim.1ddac350.png";